export const REQUEST_BODY = { application: 'klickbox' };
export const MINUTES_TO_UPDATE = 10;
export const PATH = 'users/token';



/** WEBPACK FOOTER **
 ** ./src/helpers/request/config/token.js
 **/